import { Center, Stack, Text, Button, Group } from '@mantine/core'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { IconHourglassHigh, IconArrowLeft, IconUsers } from '@tabler/icons-react'

/**
 * Shown when the player has finished every released session but the story still
 * has unreleased sessions ahead — i.e. they're caught up and waiting for the
 * facilitator to release the next one. Crucially distinct from the completion
 * screen: the session stays in_progress, so re-entering after the next release
 * drops them straight into the new session (no "Play Again", no debrief).
 */
export function SessionWaitingScreen({ story, releasedCount, totalCount }) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const teamId = searchParams.get('team')
  const inTeamFlow = !!teamId

  const goBackToTeam = () => navigate(`/teams/${teamId}`)
  const goBackHome = () => navigate('/')

  return (
    <Center style={{ height: '100%', overflow: 'auto' }}>
      <Stack align="center" gap="lg" maw={420} px="md">
        <IconHourglassHigh
          size={64}
          color="var(--mantine-color-cyan-4)"
          style={{ filter: 'drop-shadow(0 0 10px rgba(0, 229, 255, 0.4))' }}
        />

        <Text
          size="2rem"
          fw={700}
          ff="Orbitron, sans-serif"
          c="cyan.3"
          ta="center"
          className="glow-text-cyan"
        >
          You're All Caught Up
        </Text>

        <Text c="dimmed" ta="center" size="lg">
          You've finished every session released so far in{' '}
          <Text span c="cyan.4" fw={600}>
            {story?.name || 'this story'}
          </Text>
          .
          {Number.isFinite(releasedCount) && Number.isFinite(totalCount) && (
            <>
              {' '}
              <Text span c="cyan.4" fw={600}>
                {releasedCount} of {totalCount}
              </Text>{' '}
              sessions are open.
            </>
          )}{' '}
          Your facilitator will release the next one shortly — check back then and
          you'll pick up right where you left off.
        </Text>

        <Group gap="md" mt="md">
          {inTeamFlow ? (
            <Button
              variant="light"
              color="cyan"
              leftSection={<IconUsers size={16} />}
              onClick={goBackToTeam}
            >
              Back to Team
            </Button>
          ) : (
            <Button
              variant="light"
              color="gray"
              leftSection={<IconArrowLeft size={16} />}
              onClick={goBackHome}
            >
              Back to Stories
            </Button>
          )}
        </Group>
      </Stack>
    </Center>
  )
}
